import { useState } from "react";
import "./Help.css";

export default function Screenshot({ src, alt, marks = [], caption }) {
  const [failed, setFailed] = useState(false);
  if (failed) return null;

  return (
    <figure className="help-shot">
      <a className="help-shot__frame" href={src} target="_blank" rel="noopener noreferrer" title="Open the full-size image">
        <img src={src} alt={alt} loading="lazy" onError={() => setFailed(true)} />
        {marks.map((mark) => (
          <span key={mark.n} className="help-shot__mark" style={{ left: `${mark.x}%`, top: `${mark.y}%` }} aria-hidden="true">
            {mark.n}
          </span>
        ))}
      </a>
      {marks.length > 0 && (
        <ol className="help-shot__legend">
          {marks.map((mark) => (
            <li key={mark.n}>
              <span className="help-shot__legend-n" aria-hidden="true">{mark.n}</span>
              <span>{mark.text}</span>
            </li>
          ))}
        </ol>
      )}
      {caption && <figcaption>{caption}</figcaption>}
    </figure>
  );
}
